module.exports = "/images/bobsled.png?f262f7267dd754a4282ee660ac45bb0c";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/MysticIcon/icons/bobsled.png
// module id = oy6N
// module chunks = 0